import React, { Component } from 'react';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import SingleCompanySelector from '../selectors/company/SingleCompanySelector';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';

const log = new Logger('VAT_GROUPS_ADD_NEW_VAT_GROUP_CHILD', LOG_LEVELS.DEBUG);


class AddNewVATGroupChild extends Component {

    filterSelectionHandler(keyValuePairs) {
        log.debug('filterSelectionHandler() Key value pairs: ', keyValuePairs,this.props.companyId);
        var fieldName = '', value = '';

        for (var i in keyValuePairs) {
            fieldName = i;

            value = keyValuePairs[i];
            var companyIds = [];
            if(this.props.childCompanyList !== undefined && this.props.childCompanyList.length > 0)
            {
                log.debug('filterSelectionHandler() Key value pairs: in if ');
                let index = this.props.childCompanyList.length -1;
                companyIds = this.props.childCompanyList;
                log.debug('filterSelectionHandler() Key value pairs: in if ',companyIds);

                companyIds.push(Number(value));

                log.debug('filterSelectionHandler() Key value pairs: in if ',companyIds);

            }else {
                companyIds.push(Number(value));
            }
            this.props.addChildVATGroupHandler(this.props.companyId, companyIds);
        }
    }


    deleteClickHandler()
    {
        if(this.props.siblingCompanyList !== undefined && this.props.siblingCompanyList.length > 0)
        {
            var companyIds = [];

            if (window.confirm('Are you sure you wish to delete this item?')) {
                log.debug('deleteClickHandler in if ');
                companyIds = this.props.siblingCompanyList;
                log.debug('deleteClickHandler() Key value pairs: in if ', companyIds);

                var index = companyIds.indexOf(this.props.companyId);
                if (index > -1) {
                    companyIds.splice(index, 1);
                }

                log.debug('deleteClickHandler() Key value pairs: in if ', companyIds);

                this.props.addChildVATGroupHandler(this.props.parentCompanyId, companyIds);
            }
       }

    }

    render() {
        
        log.debug('render(): ', this.props);


        return (
            <ReadOnlyWrapper>
                <span>
                    <input type="checkbox" className="addChild float-left" />
                    <button onClick={this.deleteClickHandler.bind(this)} className="link delete"><LanguageStringResolver string='vatGroups_Delete'/></button>
                    <span className="AddNewPanel">
                        <fieldset className="mb10">
                            <SingleCompanySelector
                                companyList={this.props.companyList}
                                fieldName={this.props.companySelectionFieldName}
                                selectionHandler={this.filterSelectionHandler.bind(this)}
                            />
                        </fieldset>
                    </span>
                </span>
            </ReadOnlyWrapper>
        )
    }
}


export default (AddNewVATGroupChild);
